/**
 * Created by Bart Decorte
 * Date: 2019-07-16
 * Time: 15:21
 */
import TypeColumn from '../columns/TypeColumn';

class MatrixBlock {
  constructor(params) {
    this.$root = params.$root;
    this.parent = params.parent;

    if (this.isDummy()) {
      this.saveInitialDisabledState();
      this.setActive(false);
    } else {
      this.bindListeners();
    }
  }

  static dummySelector() {
    return '.js-dummy';
  }

  bindListeners() {
    this.$root.on('click', '.js-btn-expand', (ev) => {
      return this.lBtnExpandClicked(ev);
    });
    this.$root.on('click', '.js-btn-collapse', (ev) => {
      return this.lBtnCollapseClicked(ev);
    });
    this.$root
      .find('.js-block-header')
      .first()
      .on('click', (ev) => {
        return this.lHeaderClicked(ev);
      });
    this.$root.on('click', '.js-block-add-above', (ev) => {
      return this.lBlockAddAboveClicked(ev);
    });
    this.$root.on('click', '.js-block-delete', (ev) => {
      return this.lBlockDeleteClicked(ev);
    });
  }

  lBtnExpandClicked(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    this.expand();
  }

  lBtnCollapseClicked(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    this.expand(false);
  }

  lHeaderClicked(ev) {
    ev.preventDefault();
    // Prevent clicks on the dropdown menu triggering expanding & collapsing
    if (ev.target.closest('.js-dropdown-toggle')) {
      return true;
    }
    this.toggle(this.$root);
  }

  lBlockAddAboveClicked(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    let $elt = $(ev.target);
    $elt = $elt.hasClass('js-block-add-above')
      ? $elt
      : $elt.parents('js-block-add-above').first();

    const $dropdownItem = $elt.parent();
    if ($dropdownItem.is('.disabled')) {
      return;
    }

    this.addBlock($elt.data('block-type'));
  }

  lBlockDeleteClicked(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    this.deleteBlock();
  }

  header() {
    return this.$root.find('.js-block-header').first();
  }

  body() {
    return this.$root.find('.js-block-body').first();
  }

  expand(doExpand = true, mindSelection = true) {
    if (mindSelection && this.parent.hasSelectedBlocks()) {
      this.parent.callOnSelectedBlocks('expand', [doExpand, false]);
      return this;
    }

    const $header = this.header();
    const $body = this.body();
    const $input = this.$root.find('.js-block-collapsed');

    if (doExpand) {
      $body.slideDown();
      if (this.$root.hasClass('collapsed')) {
        this.$root.removeClass('collapsed');
      }
      $header.attr('aria-expanded', 'true');
    } else {
      $body.slideUp();
      if (this.$root.hasClass('collapsed')) {
        this.$root.removeClass('collapsed');
      }
      $header.attr('aria-expanded', 'false');
    }
    $input.val(doExpand ? 0 : 1);

    return this;
  }

  toggle() {
    const $header = this.header();
    const $body = this.body();
    const $input = this.$root.find('.js-block-collapsed').first();

    $body.slideToggle();
    this.$root.toggleClass('collapsed');
    const ariaExpanded = $header.is(':not([aria-expanded="false"])');
    $header.attr('aria-expanded', ariaExpanded ? 'false' : 'true');
    $input.val(ariaExpanded ? 1 : 0);
    return this;
  }

  is(selector) {
    return this.$root.is(selector);
  }

  id() {
    return this.$root.data('entry-id');
  }

  isDummy() {
    return this.$root.is(MatrixBlock.dummySelector());
  }

  setType(type) {
    const $typeColumn = this.$root
      .find('.js-column[data-column-type="TYPE"]')
      .first();

    if (!$typeColumn.length) {
      return this;
    }

    const $select = $typeColumn.find('.js-column-value');

    if (!$select.length) {
      return this;
    }

    if (typeof type === typeof undefined) {
      type = $select
        .children()
        .first()
        .attr('value');
    }

    const label = TypeColumn.label(type);
    this.$root.find('.js-type').text(label);
    $select.val(type).trigger('change');
    return this;
  }

  setSortValue(position) {
    this.$root.find('.js-block-sort').val(position);
    return this;
  }

  formElements() {
    return this.$root.find('input, textarea, select, button');
  }

  saveInitialDisabledState() {
    const $formElements = this.formElements();
    for (let i = 0; i < $formElements.length; i++) {
      let $elt = $($formElements[i]);
      $elt
        .data('disabled-initially', $elt.is(':disabled'))
        .attr('data-disabled-initially', $elt.is(':disabled'));
    }
    return this;
  }

  setActive(isActive = true) {
    let $formElements = this.formElements();
    if (isActive) {
      $formElements = $formElements.filter(
        ':not([data-disabled-initially="true"])'
      );
    }
    $formElements.prop('disabled', !isActive);
  }

  html() {
    return this.$root
      .clone()
      .wrap('<div></div>')
      .parent('div')
      .html();
  }

  position() {
    const $siblings = this.$root
      .parent()
      .children('.js-block:not(.js-block-deleted)');
    return $siblings.index(this.$root);
  }

  addBlock(type) {
    this.parent.addBlock(type, this.position());
  }

  deleteBlock(mindSelection = true) {
    if (mindSelection && this.parent.hasSelectedBlocks()) {
      this.parent.callOnSelectedBlocks('deleteBlock', [false]);
      return this;
    }

    this.parent.deleteBlock(this);
    return this;
  }

  setDeleted() {
    if (!this.$root.hasClass('matrix-block-deleted')) {
      this.$root.addClass('matrix-block-deleted');
    }
    if (!this.$root.hasClass('js-block-deleted')) {
      this.$root.addClass('js-block-deleted');
    }
    this.$root.find('.js-block-deleted').val(1);
  }
}

export default MatrixBlock;



// WEBPACK FOOTER //
// ./resources/assets/js/matrix/MatrixBlock.js